import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CATEGORIES } from "@/lib/constants";
import { BrandedImage } from "@/components/site/BrandedImage";
import { Play, Flame } from "lucide-react";

export default function VideoHub() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const category = params.get("category") || "toate";
  const vtype = params.get("type") || "";

  useEffect(() => {
    api.get("/videos", { params: { category, video_type: vtype || undefined, limit: 60 } })
      .then(r => setItems(r.data || []))
      .catch(() => {});
  }, [category, vtype]);

  const set = (k, v) => {
    const p = new URLSearchParams(params);
    if (!v || v === "toate") p.delete(k); else p.set(k, v);
    setParams(p);
  };

  return (
    <div data-testid="page-video-hub" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <header className="mb-10">
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Hub Video</p>
        <h1 className="font-display text-4xl md:text-6xl text-[#F8F8F4]">Documentar emoțional. TikTok viral. Live.</h1>
        <p className="mt-4 text-[#A0AABF] max-w-2xl text-lg">Cele mai puternice mesaje vizuale despre alienare parentală, relații și vindecare.</p>
      </header>

      <div className="flex gap-2 flex-wrap mb-6">
        <button onClick={() => set("category", "toate")} className={`px-4 py-2 text-sm rounded-sm ${category === "toate" ? "bg-[#D4A63D] text-[#0A1020]" : "bg-white/5 text-[#A0AABF] hover:bg-white/10"}`}>Toate categoriile</button>
        {CATEGORIES.map(c => (
          <button key={c.value} onClick={() => set("category", c.value)} data-testid={`vcat-${c.value}`} className={`px-4 py-2 text-sm rounded-sm ${category === c.value ? "bg-[#D4A63D] text-[#0A1020]" : "bg-white/5 text-[#A0AABF] hover:bg-white/10"}`}>{c.label}</button>
        ))}
      </div>
      <div className="flex gap-2 flex-wrap mb-10">
        <button onClick={() => set("type", "")} className={`px-3 py-1.5 text-xs uppercase tracking-wider rounded-sm border ${!vtype ? "border-[#D4A63D] text-[#D4A63D]" : "border-white/10 text-[#A0AABF]"}`}>Toate tipurile</button>
        <button onClick={() => set("type", "youtube")} className={`px-3 py-1.5 text-xs uppercase tracking-wider rounded-sm border ${vtype === "youtube" ? "border-[#D4A63D] text-[#D4A63D]" : "border-white/10 text-[#A0AABF]"}`}>YouTube</button>
        <button onClick={() => set("type", "tiktok")} className={`px-3 py-1.5 text-xs uppercase tracking-wider rounded-sm border ${vtype === "tiktok" ? "border-[#D4A63D] text-[#D4A63D]" : "border-white/10 text-[#A0AABF]"}`}>TikTok</button>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(v => (
          <Link key={v.video_id} to={`/video/${v.video_id}`} data-testid={`vid-${v.video_id}`} className="cinematic-card rounded-lg overflow-hidden group">
            <div className="relative aspect-video">
              <BrandedImage
                src={v.thumbnail}
                alt={v.title}
                className="absolute inset-0 w-full h-full group-hover:scale-105 transition-transform duration-700"
                watermarkPosition="bl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1020] via-transparent to-transparent pointer-events-none z-[5]" />
              <span className="absolute top-3 left-3 text-[10px] uppercase tracking-widest text-[#D4A63D] bg-[#0A1020]/85 px-2 py-1 border border-[#D4A63D]/30 z-10">{v.video_type}</span>
              {v.is_viral && <span className="absolute top-3 right-3 text-[10px] text-[#C83A3A] bg-black/70 px-2 py-1 flex items-center gap-1 z-10"><Flame className="w-3 h-3" /> Viral</span>}
              <div className="absolute bottom-3 right-3 w-12 h-12 rounded-full grid place-items-center bg-[#D4A63D] text-[#0A1020] z-10"><Play className="w-5 h-5 fill-current" /></div>
            </div>
            <div className="p-4">
              <h3 className="font-display text-base md:text-lg text-[#F8F8F4] line-clamp-2 group-hover:text-[#D4A63D]">{v.title}</h3>
              <p className="text-xs text-[#A0AABF] mt-2 line-clamp-2">{v.description}</p>
              <div className="mt-3 flex items-center justify-between text-xs text-[#6C7A9C]">
                <span>{v.views_count?.toLocaleString("ro-RO")} vizualizări</span>
                <span>{Math.floor(v.duration/60)}:{String(v.duration%60).padStart(2,"0")}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
